import { useCallback } from "react";

import Input, { type InputProps } from "./Input";

type NumberInputProps = Omit<InputProps<number>, "type" | "parse">;

const NumberInput = ({
  value,
  placeholder,
  label,
  leading,
  trailing,
  isRequired,
  isDisabled,
  min,
  max,
  step,
  onChange,
  width,
  fillWidth,
}: NumberInputProps) => {
  const handleChange = useCallback(
    (newValue: number | null) => {
      if (newValue === null) {
        return min ?? undefined;
      }
      if (min !== undefined && newValue < min) {
        return min;
      }
      if (max !== undefined && newValue > max) {
        return max;
      }
      onChange(newValue);
    },
    [min, max, onChange],
  );

  return (
    <Input
      type="number"
      value={value}
      placeholder={placeholder}
      label={label}
      leading={leading}
      trailing={trailing}
      isRequired={isRequired}
      isDisabled={isDisabled}
      min={min}
      max={max}
      step={step}
      onChange={handleChange}
      parse={Number}
      width={width}
      fillWidth={fillWidth}
    />
  );
};

export default NumberInput;
